import 'url-search-params-polyfill'

export default class RequestExecutorHelper {

    public getResponse(
        url: string,
        method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'HEAD',
        params?: any,
        postDataParams?: any,
        headers?: HeadersInit,
        showNotifications?: boolean
    ): Promise<Response> {
        let fetchParams: RequestInit = {
            method: method,
            body: postDataParams,
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'Access-Control-Allow-Origin' : '*', 
                'Access-Control-Allow-Credentials' : 'true' 
            },
            redirect: 'manual',
            // referrer: 'no-referrer',
        }
        if (headers) {
            Object.assign(fetchParams.headers, headers)
        }

        return fetch(url, fetchParams)
    }

    public get(url: string, params?: Object, headers?: HeadersInit): Promise<Response> {
        return this.getResponse(url, 'GET', params, null, headers)
    }

    public head(url: string) {
        return this.getResponse(url, 'HEAD')
    }

    public post(url: string, data: any, headers?: HeadersInit, showNotifications?: boolean) {
        return this.getResponse(url, 'POST', {}, data, headers, showNotifications)
    }

    public delete(url: string, data: any, headers?: HeadersInit, showNotifications?: boolean) {
        return this.getResponse(url, 'DELETE', {}, data, headers, showNotifications)
    }

    public postUrlEncoded(url: string, data: any, headers?: HeadersInit): Promise<Response> {
        let urlSP = new URLSearchParams()
        for (let key in data) {
            if (data[key]) {
                urlSP.append(key, data[key])
            }
        }
        return this.getResponse(url, 'POST', {}, urlSP.toString(), headers)
    }

    public put(url: string, data: any, headers?: HeadersInit, showNotifications?: boolean) {
        return this.getResponse(url, 'PUT', {}, data, headers, showNotifications)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/RequestExecutorHelper.ts